export const INTELISIS_ACCOUNT_FIELDS = [
    {
        field: 'cuenta',
        valueKey: 'intelisis_cuenta',
        payloadKey: 'Cuenta',
        label: 'Cuenta 1',
        placeholder: 'Seleccionar cuenta 1...'
    },
    {
        field: 'cuenta2',
        valueKey: 'intelisis_cuenta2',
        payloadKey: 'Cuenta2',
        label: 'Cuenta 2',
        placeholder: 'Seleccionar cuenta 2...'
    },
    {
        field: 'cuenta3',
        valueKey: 'intelisis_cuenta3',
        payloadKey: 'Cuenta3',
        label: 'Cuenta 3',
        placeholder: 'Seleccionar cuenta 3...'
    },
    {
        field: 'cuenta4',
        valueKey: 'intelisis_cuenta4',
        payloadKey: 'Cuenta4',
        label: 'Cuenta 4',
        placeholder: 'Seleccionar cuenta 4...'
    },
    {
        field: 'cuenta5',
        valueKey: 'intelisis_cuenta5',
        payloadKey: 'Cuenta5',
        label: 'Cuenta 5',
        placeholder: 'Seleccionar cuenta 5...',
        required: false
    }
];

export const REQUIRED_INTELISIS_ACCOUNT_FIELDS = INTELISIS_ACCOUNT_FIELDS.filter(({ required }) => required !== false);
